import { useMemo, useState } from "react";
import { DashboardExecutivo } from "./pages/DashboardExecutivo";
import { LeadsParados } from "./pages/LeadsParados";
import { AtividadesPorStatus } from "./pages/AtividadesPorStatus";
import type { ActivityStatus } from "./data/types";

type Route =
  | { name: "dashboard" }
  | { name: "leads-parados" }
  | { name: "atividades"; status: ActivityStatus };

const STATUS_ROUTE_MAP: Record<string, ActivityStatus> = {
  "atividades-scheduled": "scheduled",
  "atividades-completed": "completed",
  "atividades-missed": "missed",
  "atividades-on-time": "on-time",
};

// Janela default de 17 dias usada nas screens de drill-down quando a rota
// não carrega o período do dashboard. Mantido sincronizado com o default do
// DashboardExecutivo (preset "30d"). Em produção o histórico da URL vai
// carregar isso; aqui é state em memória.
const FALLBACK_PERIOD = { periodStart: "2026-03-19", periodEnd: "2026-04-17" };

export function App() {
  const [route, setRoute] = useState<Route>({ name: "dashboard" });
  const [currentPeriod, setCurrentPeriod] = useState(FALLBACK_PERIOD);

  const navigate = useMemo(
    () => (target: string) => {
      if (target === "leads-parados") {
        setRoute({ name: "leads-parados" });
        return;
      }
      const status = STATUS_ROUTE_MAP[target];
      if (status) {
        setRoute({ name: "atividades", status });
        return;
      }
      // Rota desconhecida — fallback silencioso pro dashboard.
      setRoute({ name: "dashboard" });
    },
    []
  );

  if (route.name === "leads-parados") {
    return <LeadsParados onBack={() => setRoute({ name: "dashboard" })} />;
  }

  if (route.name === "atividades") {
    return (
      <AtividadesPorStatus
        status={route.status}
        period={currentPeriod}
        onBack={() => setRoute({ name: "dashboard" })}
      />
    );
  }

  return (
    <DashboardExecutivo
      onNavigate={navigate}
      onPeriodChange={setCurrentPeriod}
    />
  );
}
